import script from "./PagesPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./PagesPanel.vue?vue&type=script&setup=true&lang=js"

import "./PagesPanel.vue?vue&type=style&index=0&id=36b9aa06&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36b9aa06"]])

export default __exports__